import React from 'react';
import BraceletLedLogo from '../components/BraceletLedLogo';
import { Button } from '../components/ui/button';

const LogoShowcase = () => {
  return (
    <div className="min-h-screen bg-black pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-white mb-8 text-center">
          Logo Bracelet LED Contrôlé - PARTY LED
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {/* Version Grande */}
          <div className="bg-gray-900 rounded-lg p-8 text-center">
            <h3 className="text-white font-semibold mb-4">Version Grande (200px)</h3>
            <div className="flex items-center justify-center mb-4">
              <BraceletLedLogo size={200} />
            </div>
            <p className="text-gray-400 text-sm">Idéal pour header et bannières</p>
          </div>

          {/* Version Moyenne */}
          <div className="bg-gray-900 rounded-lg p-8 text-center">
            <h3 className="text-white font-semibold mb-4">Version Moyenne (120px)</h3>
            <div className="flex items-center justify-center mb-4">
              <BraceletLedLogo size={120} />
            </div>
            <p className="text-gray-400 text-sm">Idéal pour cartes produits</p>
          </div>

          {/* Version Petite */}
          <div className="bg-gray-900 rounded-lg p-8 text-center">
            <h3 className="text-white font-semibold mb-4">Version Petite (80px)</h3>
            <div className="flex items-center justify-center mb-4">
              <BraceletLedLogo size={80} />
            </div>
            <p className="text-gray-400 text-sm">Idéal pour icônes</p>
          </div>
        </div>

        {/* Sur fond blanc */}
        <div className="bg-white rounded-lg p-12 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Logo sur fond clair
          </h2>
          <div className="flex items-center justify-center">
            <BraceletLedLogo size={250} />
          </div>
        </div>

        {/* Caractéristiques */}
        <div className="bg-gray-900 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-white mb-6">Caractéristiques du Logo</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-purple-400 font-semibold mb-3">Éléments visuels :</h3>
              <ul className="text-gray-300 space-y-2">
                <li>✨ Bracelet LED en forme elliptique</li>
                <li>🎨 Dégradé violet → rose → orange</li>
                <li>💡 4 LEDs lumineuses animées</li>
                <li>📡 Ondes de contrôle Bluetooth</li>
                <li>⚡ Effets de brillance (glow)</li>
              </ul>
            </div>
            <div>
              <h3 className="text-pink-400 font-semibold mb-3">Animations :</h3>
              <ul className="text-gray-300 space-y-2">
                <li>🔄 LEDs qui pulsent (2 secondes)</li>
                <li>📶 Ondes de signal animées</li>
                <li>✨ Effet lumineux dynamique</li>
                <li>🎯 Symbole de contrôle central</li>
                <li>🏷️ Texte "PARTY LED" intégré</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <Button 
            onClick={() => window.history.back()}
            className="bg-purple-600 hover:bg-purple-700"
          >
            Retour
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
